import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../../context/AuthContext";

const inputCls =
  "w-full bg-white border border-ink/15 px-4 py-3 text-sm text-ink placeholder:text-mutedink/60 focus:outline-none focus:border-oxblood transition-colors duration-300";
const labelCls =
  "block font-mono text-[10px] uppercase tracking-[0.25em] text-mutedink mb-2";

export const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-6"
    >
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm bg-white border border-ink/10 p-8 space-y-5"
      >
        <div>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-mutedink mb-2">
            Hailey &amp; Chloe Holdings
          </p>
          <h1 className="font-serif font-light text-2xl text-ink">
            Admin sign in
          </h1>
        </div>
        <div>
          <label htmlFor="admin-email" className={labelCls}>
            Email
          </label>
          <input
            id="admin-email"
            type="email"
            required
            data-testid="admin-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
            autoComplete="username"
          />
        </div>
        <div>
          <label htmlFor="admin-password" className={labelCls}>
            Password
          </label>
          <input
            id="admin-password"
            type="password"
            required
            data-testid="admin-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
            autoComplete="current-password"
          />
        </div>
        {error && (
          <p data-testid="admin-login-error" className="text-sm text-oxblood">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="w-full bg-ink text-parchment py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-oxblood transition-colors duration-300 disabled:opacity-50"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
};
